import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Pickaxe, Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-sm bg-white rounded-xl border border-slate-200 shadow-sm p-7 sm:p-9">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <img src="/assmang-logo.png" alt="Assmang logo" className="h-9 w-auto" />
          <span className="font-display font-bold text-slate-900">ASSMANG SMME PORTAL</span>
        </Link>

        {sent ? (
          <div className="text-center">
            <div className="h-12 w-12 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
              <MailCheck className="h-6 w-6 text-emerald-600" />
            </div>
            <h1 className="font-display text-2xl font-black text-slate-900">Check your email</h1>
            <p className="text-slate-500 mt-2 text-sm">
              If <strong>{email}</strong> is registered, we've sent a password reset link. It expires in 1 hour.
            </p>
            <Link to="/login" data-testid="back-to-login-link"
              className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-[#00427A] hover:underline">
              <ArrowLeft className="h-4 w-4" /> Back to Sign In
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-black text-slate-900 tracking-tight">Forgot password</h1>
            <p className="text-slate-500 mt-2 mb-8 text-sm">Enter your registered email and we'll send you a reset link.</p>
            {error && (
              <div data-testid="forgot-error" className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>
            )}
            <form onSubmit={submit}>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Email Address</label>
              <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3.5 py-2.5 rounded-md border border-slate-300 focus:border-[#00427A] focus:ring-2 focus:ring-[#00427A]/20 outline-none mb-6"
                placeholder="you@company.co.za" />
              <button data-testid="forgot-submit-button" disabled={loading}
                className="w-full bg-[#00427A] hover:bg-[#00325C] text-white font-semibold py-2.5 rounded-md transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
                {loading && <Loader2 className="h-4 w-4 animate-spin" />} Send Reset Link
              </button>
            </form>
            <p className="text-sm text-center mt-6">
              <Link to="/login" className="text-[#00427A] font-semibold hover:underline inline-flex items-center gap-1.5">
                <ArrowLeft className="h-4 w-4" /> Back to Sign In
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
